<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="DocId"
      ref="list"
      unit="生产入库单"
      :expand-all-row="true"
      :show-checkbox="true"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      @row-select="rowSelect"
      v-if="trendShow"
      urlHash="business/stock/pdaproductionshipping"
      :temp-params="tempParams"
      :queryParamsAppend="params"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="加工阶段" label-width="85px">
          <el-select v-model="params.ProcessingType" clearable>
            <el-option
              v-for="item in machiningStageList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <el-table
      border
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      style="margin-top: 18px"
    >
      <el-table-column
        prop="SourceNo"
        label="加工单号"
        min-width="100"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="ProductNo"
        label="存货编码"
        min-width="100"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="ProductName"
        label="存货名称"
        min-width="100"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="ProductSpec"
        label="规格"
        min-width="100"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="ColorName"
        label="颜色"
        min-width="100"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="PropertyName"
        label="属性"
        min-width="100"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="UnitName"
        label="计量单位"
        min-width="100"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="Quantity"
        label="数量"
        min-width="100"
        align="right"
      >
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Price"
        label="单价"
        min-width="100"
        align="right"
        v-if="canPrice"
      ></el-table-column>
      <el-table-column
        prop="Amount"
        label="金额"
        min-width="100"
        align="right"
        v-if="canPrice"
      >
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  props: {
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {
      api: require("@/api/stock/stInDocLog").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      //加工类型
      machiningStageApi: require("@/api/ba/machiningStage").default,
      trendShow: true,
      tableData: [],
      params: {
        ProcessingType: null,
      },
      machiningStageList: [
        // { value: "注塑", label: "注塑", disabled: false },
        // { value: "特殊加工", label: "特殊加工", disabled: false },
        // { value: "配件装配", label: "配件", disabled: false },
        // { value: "产品装配", label: "装配", disabled: false },
        // { value: "产品组装", label: "组合", disabled: false },
      ],
      tempParams: {
        InType: 1,
      },
    };
  },
  activated() {},
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/stock/productionshipping");
    },
  },
  created() {
    this.getMachiningStageList();
    this.sourceTypeApi.info("生产入库单").then((res) => {
      this.tempParams.InType = res.SourceTypeId;
    });
  },
  methods: {
    getMachiningStageList() {
      this.machiningStageApi.list({ Status: 1 }).then((res) => {
        res.Data.forEach((item) => {
          this.machiningStageList.unshift({
            value: item.Name,
            label: item.Name,
          });
        });
      });
    },
    rowSelect(row) {
      let id = row.DocId;
      this.api.info(id).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data.Products;
        }
      });
    },
    shiftInventory(ids) {
      this.api.synchronous({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("操作成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
          this.reload();
        }
      });
    },
  },
};
</script>
